export const RouterSharedKeys = {
  RouterStore: {id: 'RouterStore', defaultValue: {routes: [], isUnifiedHostname: false}},
};
